import React, { PropsWithChildren } from 'react'

import { useSelector } from 'react-redux'

import { ConditionalTrackedRoute } from '@components/UI/TrackedRoute'
import { EventTrackingNames } from '@enums'
import { IApplicationState } from '@store'
import { selectBrandFanGroupMemberCount, selectBrandFanGroupName } from '@store/brandFans'
import { selectBrandFansCurrentView } from '@store/router'

interface IProps {
  hasTracking?: boolean
  eventName: EventTrackingNames
  groupId: number
  sortBy?: string
  additionalProperties?: any
}

const BrandFansGroupRowTrackedRoute: React.FC<PropsWithChildren<IProps>> = ({
  groupId,
  eventName,
  sortBy,
  hasTracking = true,
  additionalProperties,
  children,
}) => {
  const currentView = useSelector((state: IApplicationState) => selectBrandFansCurrentView(state))
  const groupName = useSelector((state: IApplicationState) =>
    selectBrandFanGroupName(state, groupId),
  )
  const totalCount = useSelector((state: IApplicationState) =>
    selectBrandFanGroupMemberCount(state, groupId),
  )
  return (
    <ConditionalTrackedRoute
      hasTracking={hasTracking}
      eventName={eventName}
      properties={{
        group_id: groupId,
        group_name: groupName,
        current_filter: currentView,
        target_sort_filter: sortBy,
        number_of_identities: totalCount,
        ...additionalProperties,
      }}
    >
      {children}
    </ConditionalTrackedRoute>
  )
}

export default BrandFansGroupRowTrackedRoute
